import React, { useCallback, useEffect, useState } from "react";
import CardHeader from "../components/common_components/CardHeader.tsx";
import { Box, Card, CardContent } from "@mui/material";
import ScoringCardContent from "../components/scoring_components/ScoringCardContent.tsx";
import SessionService from "../api_handlers/services/SessionService.ts";
import ScoringService from "../api_handlers/services/ScoringService.ts";
import { useAppSelector } from "../redux/hook.ts";
import CardContainer from "../components/common_components/CardContainer.tsx";

const Scoring = () => {
    const [team, setTeam] = useState({ id: 0, teamName: '', backgroundImage: '' });
    const [scoreCard, setScoreCard] = useState({});
    console.log("🚀 ~ Scoring ~ scoreCard:", scoreCard)
    const [collectible, setCollectible] = useState(Array);
    const [facilatorCurrentIndex, setFacilatorCurrentIndex] = useState(0);
    const [currentScore, setCurrentScore] = useState(0);
    const session = useAppSelector((state) => state.session.session);
    const sessionId = session?.sessionId;
    const teamId = session?.teamId;

    const fetchScoringCard = useCallback(async () => {
        try {
            const data = await ScoringService.getScoreCard({ sessionId, teamId });
            console.log("🚀 ~ fetchScoringCard ~ data:", data);
            const kopelsRows = data.data.scoreCard.kopels.rows;
            const preciousStonesRows = data.data.scoreCard.preciousStones.rows;

            const kopelsMap = new Map<string, Object>();
            const preciousStonesMap = new Map<string, Object>();

            kopelsRows.forEach((row) => {
                const key = row.collectibleName.toLowerCase();
                if (!kopelsMap.has(key)) {
                    kopelsMap.set(key, { [key]: { id: row.collectibleId, name: row.collectibleName, multiplier: row.multiplier, value: row.collectibleCount } });
                }
            });

            preciousStonesRows.forEach((row) => {
                const key = row.collectibleName.toLowerCase();
                if (!preciousStonesMap.has(key)) {
                    preciousStonesMap.set(key, { [key]: { id: row.collectibleId, name: row.collectibleName, multiplier: row.multiplier, value: row.collectibleCount } });
                }
            });

            const kopels = Array.from(kopelsMap.values());
            const preciousStones = Array.from(preciousStonesMap.values());

            const collectible = [
                { id: 0, type: "collectible", rows: kopels },
                { id: 1, type: "collectible", rows: preciousStones },
                { id: 2, type: "standard_credit", value: data.data.scoreCard.standardCredit },
                { id: 3, type: "bonus", rows: [] },
                { id: 4, type: "final_score", value: data.data.scoreCard.totalScore }
            ];
            setCollectible(collectible);
            setCurrentScore(data.data?.scoreCard?.totalScore);
            setScoreCard(data.data);
        } catch (err) {
            console.error("Error fetching scorecard:", err);
        }

    }, [sessionId, teamId]);

    useEffect(() => {
        const fetchTeam = async () => {
            try {
                const data = await SessionService.getTeam(sessionId, teamId);
                setTeam(data.data);
            } catch (err) {
                console.error("Error fetching team:", err);
            }
        };

        const fetchCurrentIndex = async () => {
            try {
                const data = await ScoringService.getCurrentIndex({ sessionId });
                setFacilatorCurrentIndex(data.data?.index);
            } catch (err) {
                console.error("Error fetching current index:", err);
            }
        };

        fetchTeam();
        fetchScoringCard();
        fetchCurrentIndex();

        // Call `fetchCurrentIndex` every 5 seconds
        const intervalId = setInterval(() => {
            fetchCurrentIndex();
        }, 3000);

        // Cleanup interval on component unmount
        return () => clearInterval(intervalId);
    }, [session, fetchScoringCard, sessionId, teamId]);

    return (
        <CardContainer backgroundImageUrl={`/img/team-background/sword.png`}>
            <Card
                sx={{
                    width: { xs: '98%', sm: '95%', md: '50rem', lg: '56rem' },
                    maxWidth: { xs: '98vw', sm: '95vw' },
                    padding: 0,
                    background: 'url(/img/bg2.png)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backdropFilter: 'blur(0.3rem)',
                    borderRadius: { xs: '0.75rem', sm: '1rem', md: '1.25rem' },
                    border: '0.25rem solid rgba(139, 69, 19, 0.8)',
                    boxShadow: '0 1.5rem 4rem rgba(0, 0, 0, 0.9), 0 0 3rem rgba(139, 69, 19, 0.5), inset 0 0.25rem 0.5rem rgba(255, 255, 255, 0.15)',
                    zIndex: 1,
                    position: 'relative',
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'rgba(0, 0, 0, 0.4)',
                        pointerEvents: 'none',
                        zIndex: 0,
                    }
                }}
                variant="outlined"
                className="animate-scale-in"
            >
                <CardContent sx={{ padding: 0, '&:last-child': { paddingBottom: 0 }, width: '100%', boxSizing: 'border-box', position: 'relative', zIndex: 1 }}>
                    <Box sx={{ width: '100%', boxSizing: 'border-box', position: 'relative', zIndex: 1 }}>
                        <CardHeader teamName={team.teamName} currentScore={currentScore} isVotingStarted={true} />
                        <Box sx={{ padding: { xs: '2%', md: '3%' }, width: '100%', boxSizing: 'border-box', position: 'relative', zIndex: 1 }}>
                            <ScoringCardContent collectibles={collectible} facilatorCurrentIndex={facilatorCurrentIndex} fetchScoringCard={fetchScoringCard} />
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </CardContainer>
    );
};

export default Scoring;
